var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxSmallChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 49",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "#333333",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M5 9.4L8.375 13L14 7",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSmallChecked);
export default __webpack_public_path__ + "static/media/checkbox_small_checked.cdb2f821ae62dbd2d17347592f57247c.svg";
export { ForwardRef as ReactComponent };